import React, { useContext } from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import Image from 'next/image';
import { t } from '@lingui/macro';
import { Trans } from '@lingui/react';
import LanguageContext from '@lib/contexts/languageContext';
import { Container } from '@components/layout/Grid';

const Title = styled.h2`
  color: #3c3c3c;
  font-size: 24px;
  font-weight: 400;
  text-align: center;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  grid-gap: 20px;

  @media (min-width: ${({ theme }) => theme.viewports.tablet}px) {
    grid-template-columns: repeat(2, minmax(250px, 1fr));
  }

  @media (min-width: ${({ theme }) => theme.viewports.laptop}px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`;

const GridElement = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  background-color: ${({ theme }) => theme.colors.neutrals['light-gray']};
  overflow: hidden;

  img {
    height: 100%;
    width: 100%;
  }
`;

const FifthSection = () => {
  const lang = useContext(LanguageContext);

  const images = [
    {
      alt: t`landingpage.squareitems.alt_text.news_yogobe`,
      se: {
        link: `/${lang}/videos/genres/all`,
        img: '/static/landing/small_square_news_yogobe_se.jpg',
      },
      no: {
        link: `/${lang}/videos/genres/all`,
        img: '/static/landing/small_square_news_yogobe_no.jpg',
      },
      en: {
        link: `/${lang}/videos/genres/all`,
        img: '/static/landing/small_square_news_yogobe_en.jpg',
      },
      fi: {
        link: `/${lang}/videos/genres/all`,
        img: '/static/landing/small_square_news_yogobe_fi.jpg',
      },
    },
    {
      alt: t`landingpage.squareitems.alt_text.book_retreat`,
      se: {
        link: `/${lang}/marketplace`,
        img: '/static/landing/small_square_makretplace_se.jpg',
      },
      no: {
        link: `/${lang}/marketplace`,
        img: '/static/landing/small_square_makretplace_no.jpg',
      },
      en: {
        link: `/${lang}/marketplace`,
        img: '/static/landing/small_square_makretplace_en.jpg',
      },
      fi: {
        link: `/${lang}/marketplace`,
        img: '/static/landing/small_square_makretplace_fi.jpg',
      },
    },
    {
      alt: t`landingpage.squareitems.alt_text.program_card`,
      se: {
        link: `/se/program/lopning-kom-igang`,
        img: '/static/landing/small_square_program_se.jpg',
      },
      no: {
        link: `/no/program/yoga-for-lopere`,
        img: '/static/landing/small_square_program_no.jpg',
      },
      en: {
        link: `/en/program/mindfulness-meditation`,
        img: '/static/landing/small_square_program_en.jpg',
      },
      fi: {
        link: `/fi/ohjelmat/joogaa-aloittelijoille-viikko-1`,
        img: '/static/landing/small_square_program_fi.jpg',
      },
    },
    {
      alt: t`landingpage.squareitems.alt_text.wellness_grant`,
      se: {
        link: `/${lang}/blog/wellnet-actiway-benify-friskvardsbidrag`,
        img: '/static/landing/small_square_wellness_grant_se.jpg',
      },
      no: {
        link: `/${lang}/blog/wellnet-actiway-benify-friskvardsbidrag`,
        img: '/static/landing/small_square_wellness_grant_no.jpg',
      },
      en: {
        link: `/${lang}/blog/wellnet-actiway-benify-friskvardsbidrag`,
        img: '/static/landing/small_square_wellness_grant_en.jpg',
      },
      fi: {
        link: `/${lang}/blog/wellnet-actiway-benify-friskvardsbidrag`,
        img: '/static/landing/small_square_wellness_grant_fi.jpg',
      },
    },
  ];

  return (
    <Container flexDirection="column" px={[25, 20, 20]} py={40}>
      <Title>
        <Trans id="landingpage.section5.title" />
      </Title>
      <Content>
        {images.map((_item, i) => {
          const item = _item[lang];
          return (
            <GridElement key={i} href={item.link} title={_item.alt}>
              <Image src={item.img} alt={_item.alt} height={640} width={640} />
            </GridElement>
          );
        })}
      </Content>
    </Container>
  );
};

export default FifthSection;
